<div class="container-fluid row_banner pb-5">
  <app-header></app-header>
  <!-- Edditor  -->
  <div class="container">
    <div
      class="row text-center justify-content-center"
      style="align-content: center"
    >
      <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
        <h1
          class="w-100 fnt-w600-40"
          style="margin-top: 40px; font-size: 30px; font-weight: 700"
        >
          Text Summarizer
        </h1>
        <span
          class="w-100 d-inline-block main_text mt-40"
          style="font-size: 16px; font-weight: 500"
          >Extract key points from articles, essays, paragraphs, and research
          papers instantly.
        </span>
      </div>
    </div>
    <div class="custom-card">
      <p
        class="text-left success-msg"
        *ngIf="got_recpatcha"
        [ngStyle]="{
          color: color,
          'background-color': '#f8d7da',
          padding: '2px'
        }"
      >
        <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
        {{ recaptcha_message }}
      </p>
      <div class="row">
        <div class="col-lg-1 col-md-12 col-12 icon-bar mt45">
          <div class="icon-bar">
            <div
              class="icon-bar-img"
              id="uploadFileS"
              value="Browse"
              onclick="document.getElementById('upload').click();"
            >
              <app-icons-free-tools [name]="'pcIcon'" />
              <input
                id="upload"
                data-name="upload-element"
                #fileInput
                accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
                type="file"
                (change)="uploadFileSaveRedirect($event)"
              />
            </div>
            <div class="icon-bar-img" (click)="openDropboxChooser()">
              <app-icons-free-tools [name]="'dropboxIcon'" />
            </div>
            <div class="icon-bar-img" (click)="gDriveUpload()">
              <app-icons-free-tools [name]="'googleIcon'" />
            </div>
          </div>
        </div>
        <div class="col-lg-11 col-md-12 col-12 top-bar">
          <div class="mode-switch">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <span style="font-size: 16px; font-weight: 500"> Mode: </span>
              <div class="mode-butn">
                <button
                  class="btn default para-btn"
                  *ngIf="Paragraphmode"
                  (click)="paramode()"
                >
                  Paragraph
                </button>
                <button
                  class="btn default sentence-btn"
                  *ngIf="!Paragraphmode"
                  (click)="paramode()"
                >
                  Paragraph
                </button>
                <button
                  class="btn default sentence-btn"
                  *ngIf="!Sentencesmode"
                  (click)="sentence_modetype()"
                >
                  Sentences
                </button>
                <button
                  class="btn default para-btn"
                  *ngIf="Sentencesmode"
                  (click)="sentence_modetype()"
                >
                  Sentences
                </button>
              </div>
            </div>
            <div class="sumry-lable">
              <label
                for="summaryRange"
                style="font-size: 16px; font-weight: 500"
                >Summary Length:</label
              >
              <div class="summary-length-slider mt-0" style="display: flex">
                <span style="font-size: 14px; font-weight: 500"> Short </span>
                <div class="slider-container">
                  <input
                    id="summaryRange"
                    type="range"
                    min="0"
                    max="100"
                    [value]="percentage"
                    [(ngModel)]="percentage"
                    (input)="updatePercentage()"
                    #slider
                    (input)="updateSliderStyle($event)"
                  />
                </div>
                <span style="font-size: 14px; font-weight: 500"> Long </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12" style="overflow: hidden">
              <div
                class="upload-section"
                id="editor"
                #editor
                ngDefaultControl
                contenteditable="true"
                style="overflow-y: auto; overflow-x: hidden"
                (click)="onclickeditor($event)"
                (keyup)="getContent($event, text)"
                spellcheck="false"
                data-gramm="false"
              ></div>
              <div *ngIf="showParagraph" class="editSectionDiv">
                <div *ngFor="let content of contentArray">
                  <app-icons-free-tools [name]="'checktextIcon'" />
                  <h3 class="editor-heading">{{ content.header }}</h3>
                  <p class="paragraph">{{ content.paragraph }}</p>
                  <div class="upload-buttons">
                    <button
                      [ngClass]="{
                        paste: button.text === 'Sample Text',
                        click: button.text === 'Paste Text',
                        'default-class': true
                      }"
                      *ngFor="let button of content.buttons"
                      class="textButtons"
                      (click)="executeAction(button.action)"
                    >
                      <app-icons-free-tools [name]="button.icon" />{{
                        button.text
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <span *ngIf="char_count !== 0">
                <app-icons-free-tools
                  [name]="'deleteIcon'"
                  (click)="deleteText()"
                  class="icon-del"
                />
              </span>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12">
              <div class="result-section" id="summrizesection">
                <img
                  src="../../assets/images/summrizer/summrizer/response.svg"
                  class="result-section-img"
                  style="
                    position: relative;
                    top: 40%;
                    left: 49%;
                    text-align: center;
                    transform: translate(-50%, -50%);
                    display: block;
                  "
                />
              </div>
            </div>
            <div class="progress-loader-div">
              <div class="progress-loader" *ngIf="loaderAlert"></div>
            </div>
            <div class="edit-buttons">
              <div class="word-count">
                <p class="word-limit">
                  Words: {{ char_count === 0 ? 0 : word_count }}
                </p>
                <p cl>Total Characters: {{ char_count }}</p>
              </div>
              <div class="right-buttons">
                <div class="after-reponse" style="display: flex">
                  <button
                    id="adv-tech"
                    class="download-img tooltipss butn retry-btn"
                    aria-label="Try Again"
                    (click)="handleButtonClick()"
                    *ngIf="menuafterresponse"
                  >
                    <img id="retry" /> <span class="tooltiptext">Retry</span>
                  </button>
                  <button
                    id="adv-tech"
                    class="download-img tooltipss butn copy-btn"
                    (click)="copyText()"
                    *ngIf="menuafterresponse"
                  >
                    <img
                      src="../../assets/images/About us-assets/copy-frame.svg"
                      alt=""
                    />
                    <span class="tooltiptext">Copy</span>

                    <span
                      class="tooltiptext"
                      id="copried_txt"
                      *ngIf="!showParagraph && copiedtext"
                      >Copied</span
                    >
                  </button>
                  <button
                    class="mr-1 unquieBtn"
                    (click)="downloadText()"
                    *ngIf="menuafterresponse"
                  >
                    <img
                      src="../assets/images/plagiarism checker1/downPlag.svg"
                      alt="download-img"
                      style="margin-right: 5px"
                      class="unquieBtnImg"
                    />
                    <span>Download</span>
                  </button>
                </div>

                <button
                  class="btn btn-dark btn-summarize"
                  (click)="handleButtonClick()"
                >
                  Summarize Text
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="captchaVisible" class="captcha-modal-overlay">
            <div class="captcha-modal">
              <div
                id="recaptcha-container"
                class="recaptcha-container"
                data-size="compact"
                data-theme="light"
              ></div>
            </div>
          </div>

          <div
            *ngIf="error"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="error"
            class="content-div"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center" style="margin-top: 9%">
              <app-icons-free-tools name="errorIcon" />

              <div style="width: 440px; height: 64px; margin-left: 16px">
                <p
                  class="error mt-4 content-div-p"
                  style="
                    font-size: 20px;
                    font-weight: 500;
                    line-height: 33.89px;
                  "
                >
                  {{ errorAlerts }}
                </p>
              </div>

              <button class="mt-4 butn-alert" (click)="closeErrorDiv()">
                Ok
              </button>
            </div>
          </div>

          <div
            *ngIf="success"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="success"
            class="content-div"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center" style="margin-top: 9%">
              <app-icons-free-tools name="successIcon" />
              <p
                *ngIf="success"
                class="error mt-4 content-div-p"
                style="font-size: 24px; font-weight: 500; line-height: 33.89px"
              >
                {{ successAlert }}
              </p>
            </div>
          </div>
          <!-- code for validation  -->
        </div>
      </div>
    </div>
  </div>
  
</div>
<div
    class="container justify-content-center"
    id="how-to-use-bg "
    style="margin-top: 90px"
  >
    <div class="row mt-5" style="box-sizing: border-box">
      <div class="col-md-12">
        <h2
          style="
            text-align: center;
            font-size: 30px;
            font-weight: 700;
            line-height: 37.8px;
            text-align: center;
          "
          class="mbl-view"
        >
          How to Use Text Summarize?
        </h2>
      </div>
      <div
        class="col-md-12"
        style="
          text-align: center;
          font-size: 16px;
          font-weight: 500;
          line-height: 30px;
        "
      >
        <p>
          Summarizing a text becomes an easily performable task with this text
          summarizer. By following the simple steps, you can <br />summarize a
          lengthy text in no time.
        </p>
      </div>
    </div>
  </div>
<div class="container">
  <div class="row justify-content-center">
    <div class="col-md-4">
      <div class="summ-envision-content" style="display: flex">
        <img
          src="../../assets/images/summrizer/summrizer/upload.svg"
          alt="Vector1"
          class="summ-content-img"
        />
        <p class="summ-content-p">
          Enter text or upload a document to summarize.
        </p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="summ-envision-content">
        <img
          src="../../assets/images/summrizer/summrizer/select a mode.svg"
          alt="Vector2"
          class="summ-content-img"
        />
        <p class="summ-content-p">
          Select the mode that best fits your needs from the options provided.
        </p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="summ-envision-content">
        <img
          src="../../assets/images/summrizer/summrizer/now click.svg"
          alt="Vector3"
          class="summ-content-img"
        />
        <p class="summ-content-p">
          Now, click on the “Summarize Text” button to initiate the procedure.
        </p>
      </div>
    </div>
  </div>
  <div class="row justify-content-center mt-md-5">
    <div class="col-md-4">
      <div class="summ-envision-content">
        <img
          src="../../assets/images/summrizer/summrizer/the tool will.svg"
          alt="Vector4"
          class="summ-content-img"
        />
        <p class="summ-content-p">
          The tool will analyze your text and extract its main points.
        </p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="summ-envision-content">
        <img
          src="../../assets/images/summrizer/summrizer/copy the summarized.svg"
          alt="Vector5"
          class="summ-content-img"
        />
        <p class="summ-content-p">
          Copy the summarized text and paste it into your writing project.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="container mt-5">
  <app-premium />
</div>

<div class="container justify-content-center mt-5" id="para-key-main">
  <div class="container">
    <div class="row">
      <h2 class="fnt-w600-40 text-center mt-5">
        Benefits of Using Text Summarizer
      </h2>
      <p style="text-align: center; margin-top: 20px" class="fnt-18-400">
        The web-based text summarizer gives its users the liberty to extract the
        main concept of any text within no time. The other key advantages of
        using this text summarizer are shared below.
      </p>
      <div class="tabs_wrapper">
          <div class="btns-divs">
            <button
              class=" mybtn p-2"
              [ngClass]="{ active: selectedTab === 'tab1' }"
              (click)="selectTab('tab1')"
              id="adv-tech"
            >
              <img
                id="enhance-efficiency"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="plag-img"
              />
              <h3 class="section-3-plag-tabs-p" style="margin-top: 5px">
                Enhance Efficiency
              </h3>
            </button>
            <button
              class=" mybtn p-2"
              [ngClass]="{ active: selectedTab === 'tab2' }"
              (click)="selectTab('tab2')"
              id="adv-tech"
            >
              <img
                id="quick-output"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="plag-img"
              />
              <h3 class="section-3-plag-tabs-p">Quick Output</h3>
            </button>
            <button
              class=" mybtn p-2"
              [ngClass]="{ active: selectedTab === 'tab3' }"
              (click)="selectTab('tab3')"
              id="adv-tech"
            >
              <img
                id="improve-research"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="plag-img"
              />
              <h3 class="section-3-plag-tabs-p" style="margin-top: 0px">
                Improves Research
              </h3>
            </button>
            <button
              class=" mybtn p-2"
              [ngClass]="{ active: selectedTab === 'tab4' }"
              (click)="selectTab('tab4')"
              id="adv-tech"
            >
              <img
                id="key-information"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="plag-img"
              />
              <h3 class="section-3-plag-tabs-p">Extract Key Information</h3>
            </button>
          </div>
          <div
            class="tab_container"
            style="background-color: #f7f7fa; border-radius: 8px"
          >
            <div *ngIf="selectedTab === 'tab1'" class="tab_content">
              <p id="contentss">
                Going through lengthy content to learn its main idea definitely
                demands proper time. But our online text summarizer allows you
                to take off the key information of any article, essay, or piece
                of text instantly. The support of this online tool will reduce
                your efforts and give you a summary of the text, which saves you
                from investing ample time in reading lengthy content and gives
                you accurate information about the uploaded article or essay.
              </p>
            </div>
            <div *ngIf="selectedTab === 'tab2'" class="tab_content">
              <p id="contentss">
                Examining any article to find out the message conveyed by the
                writer demands the utmost attention. This becomes challenging if
                you are running short of time or if the text includes technical
                information. Our online text summarizing tool saves you from
                this hassle, and you get familiar with the main intent of a text
                effortlessly. The tool can summarize a lengthy text and give you
                precise paragraphs or bullet points, giving key insight into the
                article.
              </p>
            </div>
            <div *ngIf="selectedTab === 'tab3'" class="tab_content">
              <p id="contentss">
                Our online text summarizer helps you examine any report, essay,
                or research work like a pro. The utility allows you to take out
                the most important points of any content, which enables you to
                review multiple essays and papers in a limited time. All you are
                required to do is submit the article or essay to this text
                summarizing tool. The remaining process will be managed by the
                utility, and you will get the summary of the content.
              </p>
            </div>
            <div *ngIf="selectedTab === 'tab4'" class="tab_content">
              <p id="contentss">
                Save yourself from following any conventional method of
                extracting key points from any text, and automate this process
                with our online tool. Paste the text and fetch the core idea of
                the content within a fraction of a second.
              </p>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
<div
  class="container justify-content-center mt-5"
  style="
    margin-top: 50px;
    box-sizing: border-box;
    text-align: left;
    padding: 20px;
  "
  id="para-key-phone"
>
  <div class="row">
    <h2 class="fnt-w600-40 text-center">Benefits of Using Text Summarizer</h2>
    <p style="text-align: center; margin-top: 20px" class="fnt-18-400">
      The web-based text summarizer gives its users the liberty to extract the
      main concept of any text within no time. The other key advantages of using
      this text summarizer are shared below.
    </p>
    <div class="v-pills-tab-list row" id="v-pills-tab-list">
      <div class="" id="row_faqs">
        <div
          class="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-first-tab"
            aria-controls="q122"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q122"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Enhance Efficiency</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q122"
              class="collapse"
              id="q122"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                Going through lengthy content to learn its main idea definitely
                demands proper time. But our online text summarizer allows you
                to take off the key information of any article, essay, or piece
                of text instantly. The support of this online tool will reduce
                your efforts and give you a summary of the text, which saves you
                from investing ample time in reading lengthy content and gives
                you accurate information about the uploaded article or essay.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q64"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Quick Output</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q122"
              class="collapse"
              id="q64"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                Examining any article to find out the message conveyed by the
                writer demands the utmost attention. This becomes challenging if
                you are running short of time or if the text includes technical
                information. Our online text summarizing tool saves you from
                this hassle, and you get familiar with the main intent of a text
                effortlessly. The tool can summarize a lengthy text and give you
                precise paragraphs or bullet points, giving key insight into the
                article.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q74"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Improves Research</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q74"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                Our online text summarizer helps you examine any report, essay,
                or research work like a pro. The utility allows you to take out
                the most important points of any content, which enables you to
                review multiple essays and papers in a limited time. All you are
                required to do is submit the article or essay to this text
                summarizing tool. The remaining process will be managed by the
                utility, and you will get the summary of the content.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q81"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Extract Key Information</span
              >

              <i class="fas fa-chevron-down float-right"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q81"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                Save yourself from following any conventional method of
                extracting key points from any text, and automate this process
                with our online tool. Paste the text and fetch the core idea of
                the content within a fraction of a second.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid my-5" style="background: #ecf6f5">
  <div class="container">
    <div
      class="row justify-content-center"
      style="display: flex; align-items: center; padding: 30px 0px"
    >
      <div class="col-md-7 left-section">
        <h2 class="freeGrammarFont" id="align-center">
          How Does Our AI Summarizer Work?
        </h2>
        <p class="freeGrammarFont-p mt-3" id="align-center">
          Our text summarizer is an incredible tool that allows users to shorten
          a lengthy article or essay and extract key points from it without
          affecting its overall quality. This top-notch utility uses AI
          technology to examine your written content and then summarize it. Once
          you upload the textual content you desire to summarize, the backend
          NLP algorithms will scan it and then analyze it to learn the core idea
          of the text. After that, the tool will extract the main points from
          the text and give you a summarized piece of information containing all
          the key information of the original text. <br />
          The availability of different modes on this text summarizer allows you
          to handle the summarizing process the way you desire. Besides, the
          text summarizing process doesn’t require any manual effort from you
          except the uploading of data. The remaining process will be performed
          by the text summarizing itself, and you will get the summarized
          content instantly.
        </p>
      </div>
      <div class="col-md-5 right-section">
        <img
          class="how-to-img"
          src="../../assets/images/summrizer/summrizer/How Does Our AI Summarizer Work.svg"
          alt="text-ig"
        />
      </div>
    </div>
  </div>
</div>
<div
  class="container justify-content-center"
  id="how-to-use-bg "
  style="margin-top: 100px"
>
  <div class="row mt-5" style="box-sizing: border-box">
    <div class="col-md-12">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          font-weight: 700;
          line-height: 34px;
          text-align: center;
        "
        class="phone-view"
      >
        Major Beneficiaries of Our Text Summarizer
      </h2>
    </div>
    <div
      class="col-md-12"
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
      "
    >
      <p>
        Our AI-powered text summarizer assists people from almost every field of
        life. The major beneficiaries of this web-based text <br />
        summarizing tool are shared below.
      </p>
    </div>
  </div>
</div>
<div class="container text-center justify-content-center">
  <div class="row">
    <div class="col-lg-6">
      <img
        src="../../assets/images/summrizer/summrizer/Students and Researchers.svg"
        class="article-8-img"
        alt="summarize"
      />
    </div>
    <div class="col-lg-6">
      <h2 class="fnt-w600-30 article-8-h2 mt-5">Students and Researchers</h2>
      <p class="fnt-18-400 mt-4 article-8-p">
        Students and researchers need to complete different written assignments
        given by their instructors. For completing the given assignments, they
        are required to conduct extensive research. Examining different papers
        and research articles thoroughly will surely consume extensive time,
        which causes challenges for them to meet the given deadline. That’s
        where our text summarizer comes to rescue them. Using this online tool,
        they can learn the primary idea of any paper or essay without reading
        the entire text. This will speed up their data collection process and
        help them submit their assignments timely.
      </p>
    </div>
  </div>
</div>
<div class="container text-center justify-content-center">
  <div class="row" id="artical-9">
    <div class="col-lg-6 left-section">
      <h2 class="fnt-w600-30 article-8-h2 mt-5">Content Writers and Authors</h2>
      <p class="fnt-18-400 mt-4 article-8-p">
        Content writers and authors are expected to provide flawless and unique
        information to their readers. However, they are often required to read
        other famous writers and authors to find new ideas. Reading lengthy
        pieces of text will consume their ample time and effort. But they can
        cut all the ambiguities swiftly with our text summarizer. This online
        tool gives them an easy way to save their resources and generate
        excellent ideas in a short span. Furthermore, it also supports them in
        transforming ordinary content into exceptional and catchy text for
        social media posts.
      </p>
    </div>
    <div class="col-lg-6 right-section">
      <img
        src="../../assets/images/summrizer/summrizer/Content Writers and Authors.svg"
        class="article-8-img"
        alt="summarize1"
      />
    </div>
  </div>
</div>
<div class="container text-center justify-content-center">
  <div class="row">
    <div class="col-lg-6">
      <img
        src="../../assets/images/summrizer/summrizer/Marketers and Business Analysts.svg"
        class="article-8-img"
        alt="summarize3"
      />
    </div>
    <div class="col-lg-6">
      <h2 class="fnt-w600-30 article-8-h2 mt-5">
        Marketers and Business Analysts
      </h2>
      <p class="fnt-18-400 mt-4 article-8-p">
        The online text summarizer offers marketers and business analysts a
        helping hand in learning to trend topics and insights into the market.
        Instead of reading blog posts and other marketing content of their
        competitors, they can simply extract the major points of their published
        content. This helps them in precising the huge amount of data and
        learning the primary idea of it in the simplest way. Focusing on the
        results will give them a hint of key elements that require their
        attention to craft a result-oriented strategy.
      </p>
    </div>
  </div>
</div>
<div class="container mt-5 qustion" id="home-faqs">
  <div
    class="row row justify-content-center"
    id="row_faqs"
    style="margin-bottom: 20px"
  >
    <div class="faqs text-center">
      <h1 class="text-center">Frequently asked questions</h1>
      <p style="text-align: center" class="text mb-5 text">
        Learn more about platform by user questions
      </p>
    </div>
    <div class="v-pills-tab-list row" id="v-pills-tab-list">
      <div id="row_faqs">
        <div
          class="container container-grid"
          style="width: min(100% - 40px, 768px)"
        >
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q5' }"
              (click)="toggleTab('q5')"
              id="v-pills-first-tab"
              aria-controls="q5"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q5'"
                >
                  Are the Results of this Summarizing Tool Accurate
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q5'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q5'"
                />
              </div>

              <div
                aria-labelledby="q5"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q5' }"
                id="q5"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  The AI-powered text summarizing tool incorporates advanced
                  technology that makes it the perfect option to summarize any
                  text. This tool has the ability to give you 100% accurate and
                  reliable summarizing text output.
                </div>
              </div>
            </a>
          </div>

          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q15' }"
              (click)="toggleTab('q15')"
              id="v-pills-2nd-tab"
              aria-controls="q15"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q15'"
                >
                  Is it Legal to Use Text Summarization?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q15'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q15'"
                />
              </div>

              <div
                aria-labelledby="q15"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q15' }"
                id="q15"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Yes! There is no illegality in using this AI summarizer tool.
                  Our text summarizing tool doesn’t generate new content. It
                  only summarizes a lengthy text and extracts the main points
                  from it. So, it is completely ethical and legal to use this
                  text summarizing tool for finding the core concept of any
                  essay or article.
                </div>
              </div>
            </a>
          </div>
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q6' }"
              (click)="toggleTab('q6')"
              id="v-pills-4th-tab"
              aria-controls="q6"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q6'"
                >
                  Does This Text Summarizer Support Multiple Languages?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q6'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q6'"
                />
              </div>

              <div
                aria-labelledby="q6"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q6' }"
                id="q6"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Yes! Our online text summarizer supports many other languages
                  besides English, such as Spanish, Italian, German, French,
                  Arabic, Hindi, and many more.
                </div>
              </div>
            </a>
          </div>

          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q7' }"
              (click)="toggleTab('q7')"
              id="v-pills-5th-tab"
              aria-controls="q7"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q7'"
                >
                  Can I Upload any Type of Text File?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q7'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q7'"
                />
              </div>

              <div
                aria-labelledby="q7"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q7' }"
                id="q7"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Yes! Our online text summarization tool gives you the
                  opportunity to upload PDF, DOC, DOCX, and other files. Simply
                  click on the Upload button and submit any text file
                  straightaway.
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-feedback></app-feedback>
<!-- end section 9 -->
<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  data-tooltip="Go to top"
>
  <app-icons-free-tools name="goToTopIcon" />
</a>

<app-premium-modal-startup />

<app-footer></app-footer>
